/**
 * Canonical books and chapter registry CRUD operations.
 * These stores are shared across users (not user-scoped).
 */

import { ensureDB, getDB, getById, put, now } from './helpers';

// =====================================================
// Canonical Books
// =====================================================

export async function getCanonicalBook(canonicalBookId) {
  return getById('canonical_books', canonicalBookId);
}

export async function putCanonicalBook(data) {
  return put('canonical_books', { ...data, updated_at: now() });
}

export async function getAllCanonicalBooks() {
  if (!(await ensureDB())) return [];
  const db = getDB();
  if (!db.objectStoreNames.contains('canonical_books')) return [];
  return new Promise((resolve, reject) => {
    const tx = db.transaction('canonical_books', 'readonly');
    const store = tx.objectStore('canonical_books');
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error);
  });
}

// =====================================================
// Chapter Registry (canonical_book → chapter hashes cache)
// =====================================================

export async function getChapterRegistry(canonicalBookId) {
  if (!(await ensureDB())) return [];
  const db = getDB();
  if (!db.objectStoreNames.contains('chapter_registry')) return [];
  return new Promise((resolve, reject) => {
    const tx = db.transaction('chapter_registry', 'readonly');
    const store = tx.objectStore('chapter_registry');
    const index = store.index('canonical_book_id');
    const request = index.getAll(canonicalBookId);
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error);
  });
}

export async function putChapterRegistryEntry(entry) {
  return put('chapter_registry', entry);
}

export async function putChapterRegistryBatch(entries) {
  if (!(await ensureDB())) return;
  const db = getDB();
  if (!db.objectStoreNames.contains('chapter_registry')) return;
  return new Promise((resolve, reject) => {
    const tx = db.transaction('chapter_registry', 'readwrite');
    const store = tx.objectStore('chapter_registry');
    for (const entry of entries) {
      store.put(entry);
    }
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
